<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>

	<form @submit.prevent="onSubmit">

		<smart-input :error="inputErrors.name" label="שם אזור" v-model="form.name"></smart-input>
		<div class="form-group">
			<v-btn type="submit" color="success">שמירה</v-btn>
		</div>
	</form>
</template>


<script>
	import AreaModule from "src/store/modules/Area.module";
	import FormView from "src/mixins/FormView";

	export default {
		props: [],
		name: "area-form",
		components: {},
		data() {
			return {
				form: {
					name: null,
				},
			};
		},
		mixins: [new FormView(AreaModule, "area")],
		computed: {
			isNew() {
				return !!this.area.id;
			}
		}
	};
</script>

<style>

</style>
